import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import ErrorBoundary from "./components/ErrorBoundary";
import { Toaster } from "./components/ui/sonner";

// Code-split admin routes — recharts is heavy and shouldn't load on the landing page
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));

function AdminFallback() {
    return (
        <div className="min-h-screen grid place-items-center bg-[#0a0d14] text-slate-400 text-sm">
            Loading...
        </div>
    );
}

function App() {
    return (
        <div className="App font-display">
            <ErrorBoundary>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route
                            path="/admin/login"
                            element={
                                <Suspense fallback={<AdminFallback />}>
                                    <AdminLogin />
                                </Suspense>
                            }
                        />
                        <Route
                            path="/admin"
                            element={
                                <Suspense fallback={<AdminFallback />}>
                                    <AdminDashboard />
                                </Suspense>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </ErrorBoundary>
            <Toaster />
        </div>
    );
}

export default App;
